import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20683400"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20683400')) {
      api.createRecord('20683400', component.options)
    } else {
      api.reload('20683400', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20683400", function () {
      api.rerender('20683400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/conversations/index.vue"
export default component.exports